import TitleSection from './title/TitleSection';
import AboutSection from './about/AboutSection';
import TestimonialsSection from './testimonials/TestimonialsSection';
import ApplySection from './apply/ApplySection';
import './Home.css';

function Home() {
  return (
    <>
      <TitleSection />
      <AboutSection />
      <TestimonialsSection />
      <ApplySection />
    </>
  );
}

export default Home;
